export default __webpack_public_path__ + "static/media/bitcoin.165ca7a6.png";